export default __webpack_public_path__ + "static/media/List-documentation.eef4e578.md";